import { Assignment, ASSIGNMENT_MODE_APPRAISAL } from 'components/Assignment';
import { connect } from 'react-redux';
import {
  getConfig,
  getZipCodes,
  getCaseLocations,
  getInspectorLocations,
  getCaseDetails,
  getAssignedCases,
  getInspectorDetails,
  removeCasesFromCaseDetailsList,
  removeCasesFromMap,
  clearMapSelection,
  clearInspectorDetails,
  assignCasesToInspector,
  unassignCases,
  clearAssignmentToolMemory,
} from 'actions/assignment';
import { savePreference, loadPreference, loadPreferences } from 'actions/preferences';
import { getCaseHeader, updateCaseHeader } from 'actions/homeowner/caseforms';
import { getCountiesByState, getCountyBoundaries, clearLoadedCountyBoundaries } from 'actions/region';
import { getStateList } from 'actions/appraiser';
import { getMultipleAppraiserCounties } from "actions/appraiserCounties";
import { updateHeader } from 'actions/layout';
import { getFieldRepList } from "actions/homeowner/fieldReps";

const mapStateToProps = (state) => ({
  ...state.assignment,
  selectedCaseHeader: state.caseForms.caseHeader,
  fetchingCaseHeader: state.caseForms.fetchingHeader,
  preferences: state.preferences,
  assignmentMode: ASSIGNMENT_MODE_APPRAISAL,
  headerSearchText: state.search.searchText,
  lastSearchTime: state.search.lastSearchTime,
  stateList: state.appraiser.stateList,
  countyList: state.region.countiesByState,
  isFetchingCountyList: state.region.isFetchingCountiesByState,
  countyBoundaries: state.region.countyBoundaries,
  isFetchingCountyBoundaries: state.region.isFetchingCountyBoundaries,
  appraiserCountiesList: state.appraiser.appraiserCountiesList,
  isFetchingAppraiserCountiesList: state.appraiser.fetchingAppraiserCountiesList,
  updatingCaseHeader: state.caseForms.updatingCaseHeader,
  FRList: state.fieldRep.fieldRepsDetailed,
  isFetchingFRList: state.fieldRep.isFetchingFieldReps,
  inspectorDetails: state.assignment.inspectorDetails
});

const mapDispatchToProps = (dispatch) => ({
  getConfig() {
    dispatch(getConfig(ASSIGNMENT_MODE_APPRAISAL));
  },
  getStateList() {
    dispatch(getStateList());
  },
  getZipCodes(stateCodeList) {
    dispatch(getZipCodes(stateCodeList));
  },
  getCountiesByState(stateCodeList) {
    dispatch(getCountiesByState(stateCodeList));
  },
  getCaseLocations(stateCodeList, caseIdFilter) {
    dispatch(getCaseLocations(ASSIGNMENT_MODE_APPRAISAL, stateCodeList, caseIdFilter));
  },
  getInspectorLocations(stateCodeList, useBreadcrumbs) {
    dispatch(getInspectorLocations(ASSIGNMENT_MODE_APPRAISAL, stateCodeList, useBreadcrumbs));
  },
  getCaseDetails(caseIds) {
    dispatch(getCaseDetails(ASSIGNMENT_MODE_APPRAISAL, caseIds));
  },
  getAssignedCases(inspectorNumber) {
    dispatch(getAssignedCases(ASSIGNMENT_MODE_APPRAISAL, inspectorNumber));
  },
  getInspectorDetails(inspectorNumbers) {
    dispatch(getInspectorDetails(ASSIGNMENT_MODE_APPRAISAL, inspectorNumbers));
  },
  assignCasesToInspector(caseIds, inspectorId, callback) {
    dispatch(assignCasesToInspector(ASSIGNMENT_MODE_APPRAISAL, caseIds, inspectorId, callback, null, false));
  },
  unassignCases(caseIds) {
    dispatch(unassignCases(ASSIGNMENT_MODE_APPRAISAL, caseIds));
  },
  removeCasesFromCaseDetailsList(data) {
    dispatch(removeCasesFromCaseDetailsList(data));
  },
  removeCasesFromMap(data) {
    dispatch(removeCasesFromMap(data));
  },
  clearMapSelection() {
    dispatch(clearMapSelection());
  },
  clearInspectorDetails() {
    dispatch(clearInspectorDetails());
  },
  clearLoadedCountyBoundaries() {
    dispatch(clearLoadedCountyBoundaries());
  },
  clearAssignmentToolMemory() {
    dispatch(clearAssignmentToolMemory());
  },
  getCaseHeader(caseId) {
    dispatch(getCaseHeader(caseId));
  },
  savePreference(code, value, callback) {
    dispatch(savePreference(code, value, callback));
  },
  loadPreference(code) {
    dispatch(loadPreference(code));
  },
  loadPreferences(codes) {
    dispatch(loadPreferences(codes));
  },
  getCountyBoundaries(countyIds) {
    dispatch(getCountyBoundaries(countyIds));
  },
  getMultipleAppraiserCounties(appraiserIds) {
    dispatch(getMultipleAppraiserCounties(appraiserIds));
  },
  updateHeader(headerDefinitions) {
    dispatch(updateHeader(headerDefinitions));
  },
  getFRList() {
    dispatch(getFieldRepList(""));
  },
  updateCaseHeader(controlNumber, dto) {
    dispatch(updateCaseHeader(controlNumber, dto));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Assignment);
